import EnvironmentVariables from 'darwin/EnvironmentVariables';

export default function getAsset(name) {
    return EnvironmentVariables.ASSETS_BASE + name;
}
